import(/* webpackMode: "eager", webpackExports: ["NotFound"] */ "/app/apps/royalur/src/app/NotFound.tsx");
